import { h } from "preact";
import css from "./style.scss";
import cx from "classnames";
import { Link } from "preact-router";
import { svgIcons } from "../../helpers/svg-helpers";

const BackTo = ({ icon = true, children, onClick }) => {
  return (
    <div onClick={onClick} class={cx(css.wrapper)}>
      {icon && <div class={cx(css.icon)}>{svgIcons.left()}</div>}
      <span>{children}</span>
    </div>
  );
};
export default BackTo;
